module.exports = __webpack_public_path__ + "img/tx.6b0188ac.png";